import React from 'react';

/**
 * ConfigSection - Reusable section header, matching original hierarchy.
 */
export const ConfigSection = ({ title, description, children, dotColor, className = "" }) => (
  <div className={`animate-in fade-in ${className}`}>
    {(title || description) && (
      <div className="mb-6">
        <h4 className="font-bold text-slate-700 text-sm flex items-center gap-2 mb-2">
          {dotColor && <span className={`w-2 h-2 rounded-full ${dotColor}`}></span>}
          {title}
        </h4>
        {description && <p className="text-[12px] text-slate-400 font-medium">{description}</p>}
      </div>
    )}
    <div className={title || description ? "mt-4" : ""}>
      {children}
    </div>
  </div>
);




